import styled from 'styled-components'

const BUTTON_STYLE = {
  marginTop: '15px',
  borderRadius: '30px',
  minWidth: '87px'
}

const Wrapper = styled.div`
  height: 100%;
  display: flex;
`

const InnerWrapper = styled.div`
  width: 500px;
  padding: 35px;
`

const Container = styled.div`
  position: relative;
  top: 15%;

  > p {
    font-size: 35px;
    font-weight: 600;
    margin-bottom: 10px;
  }

  > div {
    font-size: 15px;
    font-weight: 500;
    text-align: justify;
  }
`

const BackgroundImage = styled.div`
  background: url('/images/kid-drawing-rocket.jpg') no-repeat;
  background-size: cover;

  width: 100%;
  height: 100%;
`

export { Wrapper, InnerWrapper, Container, BackgroundImage, BUTTON_STYLE }
